export default __webpack_public_path__ + "static/media/445.f3a85c0c.png";